import getMediaGroupNodeView from '../../nodes/mediaGroup';
export function attachmentLinkResolver(link, schema, context) {
  if (link.attachmentName) {
    return [getMediaGroupNodeView(schema, link.attachmentName, context)];
  }
  return;
}